import globals from '../globals';
import Logger from '../logger';
import AuthProvider from './AuthProvider';
import DefaultClient from './DefaultClient';
import DefaultClientWithCaching from './DefaultClientWithCaching';



const dataProvider = (type, resource, params) => {

	switch (resource) {
		case RESOURCE_SALES_REPORT:
			return DefaultClientWithCaching(type, resource, params);
		default:
			return DefaultClient(type, resource, params);
	}

};
export default dataProvider;

export const BASE_URL = `${globals.API_URL}/private`;

export const RESOURCE_SALES_REPORT = 'salesreport';

const RESOURCE_PATH_MAPPING = {};
RESOURCE_PATH_MAPPING[RESOURCE_SALES_REPORT] = 'salesreport';

const isSupportedResource = (resource) => {
	return RESOURCE_PATH_MAPPING[resource];
};

export const getResourcePath = (resource, params) => {

	if (!isSupportedResource(resource)) {
		throw new Error(`Unsupported Data Provider resource: ${resource}`);
	}

    return RESOURCE_PATH_MAPPING[resource];
};

export const getAuthToken = async () => {
	return await AuthProvider.getAccessToken();
};

export const getPaginationFromParams = (params) => {

	let pagination = {
		limit: 10,
		offset: 0
	};

	if (params.pagination) {
		pagination.limit = params.pagination.perPage;
		pagination.offset = (params.pagination.page - 1) * pagination.limit;
	}

	return pagination;
};

export const decodeJSONBytes = (bytes) => {
	try {
		const json = new TextDecoder().decode(bytes);
		return JSON.parse(json);
	} catch (error) {
		Logger.error(error);
		return null;
	}
};
